<template>
  <b-modal
    centered
    id="request-device-material"
    modal-class="overflow-hidden"
    static
    scrollable
    hide-footer
    @hidden="onHidden"
    :no-close-on-backdrop="true"
    ignore-enforce-focus-selector="input"
  >
    <template #modal-header="">
      <h5>Thêm vật tư</h5>
      <b-button size="sm" variant="light" @click="closeModalRequestDevice()"> x </b-button>
    </template>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(updateDevice)">
        <div>
          <ValidationProvider rules="required" vid="deviceId" name="Serial thiết bị">
            <div class="form-group" slot-scope="{ errors }">
              <label>Tên vật tư<span style="color: red"> *</span></label>
              <div v-if="dataRequest.edit === true && dataRequest.deviceId">
                <input type="text" :value="dataRequest.serial" :disabled="true" />
              </div>
              <Select2
                v-else
                v-model="dataRequest.deviceId"
                @change="
                  getQuantityDevice(dataRequest.deviceId), findAbbreviation(dataRequest.deviceId)
                "
                :options="dataSerial"
                placeholder="Chọn vật tư"
              />
              <p class="text-danger">{{ errors[0] }}</p>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="" vid="errorsIds" name="Số lượng trên hệ thống">
            <div class="form-group" slot-scope="{ errors }">
              <label>Số lượng trên hệ thống </label>
              <input type="text" :value="beforeChangeQuantity" disabled />
              <p class="text-danger">{{ errors[0] }}</p>
            </div>
          </ValidationProvider>
          <ValidationProvider
            rules=""
            vid="quantityAvailability"
            name="Số lượng khả dụng trên hệ thống"
          >
            <div class="form-group" slot-scope="{ errors }">
              <label>Số lượng khả dụng trên hệ thống </label>
              <input type="text" :value="quantityAvailability" disabled />
              <p class="text-danger">{{ errors[0] }}</p>
            </div>
          </ValidationProvider>
          <ValidationProvider
            rules=""
            vid="quantityLock"
            name="Số lượng thiết bị khoá trên hệ thống"
          >
            <div class="form-group" slot-scope="{ errors }">
              <label>Số lượng thiết bị khoá trên hệ thống </label>
              <input type="text" :value="quantityLock" disabled />
              <p class="text-danger">{{ errors[0] }}</p>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="required" vid="reason" name="Số lượng thực tế">
            <div class="form-group" slot-scope="{ errors }">
              <label>Số lượng thực tế <span style="color: red"> *</span></label>
              <input type="number" v-model="dataRequest.afterChangeQuantity" />
              <p class="text-danger">{{ errors[0] }}</p>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="required|minMaxName_6" vid="note" name="Ghi chú">
            <div class="form-group" slot-scope="{ errors }">
              <label>Ghi chú <span style="color: red"> *</span></label>
              <div>
                <input type="text" class="form-control" v-model="dataRequest.note" />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
        </div>
        <div class="div-btn">
          <b-button
            class="btn-style"
            size="sm"
            type="button"
            variant="light"
            @click="closeModalRequestDevice()"
          >
            Hủy bỏ
          </b-button>
          <b-button class="btn-style" type="submit" size="sm" variant="primary">
            Xác nhận
          </b-button>
        </div>
      </form>
    </ValidationObserver>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
  </b-modal>
</template>

<script>
  import { DeviceService } from '@/services/device.service'
  import Config from '@/thirdParty/config'
  export default {
    name: 'modal-quantity-material',
    props: {
      dataSerial: {
        type: Array,
        default: Array,
      },
      inventoryId: {
        type: String,
        default: '',
      },
      lsData: {
        type: Object,
        default: Object,
      },
      closeModalRequestDevice: {
        type: Function,
      },
    },
    data() {
      return {
        Config,
        showLoading: false,
        errorsIds: [],
        dataRequest: {},
        beforeChangeQuantity: null,
        quantityAvailability: null,
        quantityLock: null,
      }
    },
    created() {
      if (this.lsData) {
        this.dataRequest = this.lsData ?? []
      }
    },
    watch: {
      lsData(val) {
        if (val && val.edit) {
          this.dataRequest = val ?? []
        }
      },
    },
    methods: {
      updateDevice() {
        const data = {
          categoryId: this.dataRequest.deviceId,
          abbreviation: this.dataRequest.abbreviation,
          categoryName: this.dataRequest.categoryName,
          dateConfirm: Date.now(),
          beforeChangeQuantity: this.beforeChangeQuantity,
          note: this.dataRequest.note,
          afterChangeQuantity: this.dataRequest.afterChangeQuantity,
          changeQuantity:
            Number(this.dataRequest.afterChangeQuantity) - Number(this.beforeChangeQuantity),
          edit: this.dataRequest.edit,
        }
        this.$emit('updateDevice', data)
      },
      onHidden() {
        this.$emit('onHidden')
      },
      async getQuantityDevice(id) {
        console.log(id)
        try {
          this.showLoading = true
          const res = await DeviceService.getQuantityOfDevice({
            inventoryId: this.inventoryId,
            categoryId: id,
          })
          this.beforeChangeQuantity = res.data.quantity
          this.quantityAvailability = res.data.quantityAvailability ?? 0
          this.quantityLock = res.data.quantityLock ?? 0
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      cancel() {
        this.$bvModal.hide('request-device-error')
      },
      async findAbbreviation(deviceId) {
        const data = this.dataSerial.find(item => item.id === deviceId)
        this.dataRequest.abbreviation = data.abbreviation
        this.dataRequest.categoryName = data.text
      },
    },
  }
</script>

<style scoped>
  .btn-style {
    border-radius: 0.25rem;
    line-height: 1.5;
    padding: 0.4rem 0.75rem;
    font-weight: 400;
    margin: 0.25rem;
  }
  .div-btn {
    text-align: right;
  }
</style>
